import React from 'react';
import Chip from '@mui/material/Chip';

type Props = {
    label: string;
    count: number;
} & Omit<React.ComponentProps<typeof Chip>, 'label'>;

const NumberChip = ({ label, count, ...rest }: Props) => {
  const chipLabel = `${label}: ${count}`;

  return (
    <Chip label={chipLabel} {...rest} />
  );
};

export default NumberChip;
